<form
  class="filters-bar flex-grid filter-forms"
  [ngClass]="isDownloadReportList ? 'is-download-report-list' : ''"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <div *ngIf="addBackLink || backLinkRoute" class="back-arrow">
    <a miq-go-back-link></a>
  </div>
  <div *ngFor="let props of filters" [class]="props.css || 'col'">
    <ng-container [ngSwitch]="props.type">
      <miq-simple-select
        *ngSwitchCase="filterInputTypeEnum.Select"
        [props]="props"
        [value]="props.value"
        [optionsEndpoint]="props.optionsEndpoint"
        [disabled]="disableAll || props.disabled"
        [matTooltip]="props.tooltip"
        (selection)="emitChangeAndPatchForm($event)"
      ></miq-simple-select>

      <miq-period-range
        *ngSwitchCase="filterInputTypeEnum.PeriodRange"
        [props]="props"
        [value]="periodRangeValue"
        [marketQtd]="marketQtdValue"
        [maxValue]="maxValue"
        [reportId]="reportId"
        [reportType]="reportType"
        [type]="periodType"
        (selection)="emitChangeAndPatchForm($event)"
      ></miq-period-range>

      <ng-container *ngSwitchCase="filterInputTypeEnum.MultiSelect">
        <ng-container [ngSwitch]="props.inputType">
          <!-- NAICS input -->
          <miq-filter-naics
            *ngSwitchCase="'naics'"
            [props]="props"
            [value]="props.value"
            (selection)="emitChangeAndPatchForm($event)"
          >
          </miq-filter-naics>

          <!-- default -->
          <miq-simple-select
            *ngSwitchDefault
            [props]="props"
            [value]="props.value"
            [multi]="true"
            [optionsEndpoint]="props.optionsEndpoint"
            [disabled]="disableAll || props.disabled"
            (selection)="emitChangeAndPatchForm($event)"
          ></miq-simple-select>
        </ng-container>
      </ng-container>

      <miq-range-item
        *ngSwitchCase="filterInputTypeEnum.Range"
        [isLandingPage]="isLandingPage"
        [isReport]="isReport"
        class="forms-container"
        [filter]="props"
        [form]="form"
        (rangeChange)="emitChangeAndPatchForm($event)"
      ></miq-range-item>

      <miq-equals-filter
        *ngSwitchCase="filterInputTypeEnum.EqualNoCase"
        [props]="props"
        (search)="emitChangeAndPatchForm($event)"
      ></miq-equals-filter>

      <div [ngClass]="props.css" *ngSwitchCase="filterInputTypeEnum.ClearValues">
        <a (click)="clearFilters.emit()" id="clearfilter">{{ 'recordsSearch.clearValues' | xTranslate | uppercase }}</a>
      </div>

      <span *ngIf="props.type === 'separator'" class="divider"></span>

      <miq-search-bar
        *ngSwitchCase="filterInputTypeEnum.SearchBar"
        [searchValue]="props.value"
        [props]="props"
        (search)="emitChangeAndPatchForm($event)"
      ></miq-search-bar>

      <miq-auto-complete-bar
        *ngSwitchCase="filterInputTypeEnum.AutoCompleteBar"
        [searchValue]="props.value"
        [props]="props"
        (search)="emitChangeAndPatchForm($event)"
      >
      </miq-auto-complete-bar>
      <div style="position: relative">
        <button
          *ngSwitchCase="filterInputTypeEnum.Button"
          mat-flat-button
          color="primary"
          type="submit"
          [id]="props.id ? 'e2eFiltersBar' + props.id + 'Btn' : 'e2eFiltersBarBtn'"
        >
          UPDATE
        </button>
      </div>
    </ng-container>
  </div>
</form>
